export const seasons = ['Spring', 'Summer', 'Fall', 'Winter'];

export const threePlayerReq = [10, 20, 30, 50];
export const fourPlayerReq = [12, 25, 38, 60];

export const playerHandSizeDefault = 2; // 2, 4, 6 distribution strat
